import React, { Component } from 'react';
import Title from './Title';
import TextBlock from './TextBlock';

class Paragraph extends Component {
  render(){
    // Destructuring :)
    const { extra, titleText, pageUrl = '' } = this.props;

    return(
        <div className="container small">
            <div className="wrap">
              {titleText !== undefined || this.props.heading !== undefined
                ? <Title titleText={titleText} heading={this.props.heading} />
                : null
              }
              <TextBlock
                text={this.props.paragraph}/>
              {extra}
            </div>

        </div>
    );
  }
}

export default Paragraph;



// WEBPACK FOOTER //
// ./src/layout/Paragraph.js